import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=751d758d&scoped=true&"
import script from "./PrivacyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/terms.css?vue&type=style&index=0&id=751d758d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d758d",
  null
  
)

export default component.exports